import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import messages from './messages'

import LinesChartContainer from 'modules/Charts/Lines/LinesChartContainer'
import MapChartContainer from 'modules/Charts/Map/MapChartContainer'
import IndicatorTools from 'utils/indicators/indicatorTools'

import Loading from 'components/Loading'
import Error from 'components/Error'

class ContentChartWrapper extends Component {
  constructor(props) {
    super(props)

    const {
      intl: { formatMessage }
    } = props
    this.formatMessage = formatMessage

    this.state = {
      loading: true,
      error: false,
      levelIndicators: []
    }
  }

  componentDidMount() {
    if (this.props.level !== 0) {
      let levelIndicators = IndicatorTools.getIndicatorsFromLevel(this.props.level)

      this.setState({
        levelIndicators,
        loading: false,
        error: false
      })
    } else {
      this.setState({
        loading: false,
        error: false
      })
    }
  }

	composeCharts = ({ indicator }) => {
	  let chart = null
	  if (this.props.layer === 2) {
	    switch (this.props.chartTypeFilter) {
	    case 'evolutionAbsolute':
	      chart = this.renderLinesChart(indicator)
	      break
	    case 'map':
	      chart = this.renderMapChart(indicator)
	      break
	    default:
	      chart = null
	      break
	    }
	  } else {
	    chart = this.renderAllCharts(indicator)
	  }
	  return chart
	}

	renderLinesChart(indicator) {
	  return <LinesChartContainer indicator={indicator} />
	}

	renderMapChart(indicator) {
	  return <MapChartContainer indicator={indicator} />
	}

	renderAllCharts(indicator) {
	  return (
	    <React.Fragment>
	      <LinesChartContainer indicator={indicator} layer={this.props.layer} />
	      <MapChartContainer indicator={indicator} layer={this.props.layer} />
	    </React.Fragment>
	  )
	}

	getSubLevelTitle(subLevel) {
	  switch (subLevel) {
	  case 0:
	    return this.formatMessage(messages.businessBehavior)
	  case 1:
	    return this.formatMessage(messages.specialization)
	  case 2:
	    return this.formatMessage(messages.businessEnvironment)
	  default:
	    return ''
	  }
	}

	renderIfAllOK() {
	  let renderingComponent = null
	  if (this.state.error) {
	    renderingComponent = <Error />
	  } else if (this.state.loading) {
	    renderingComponent = <Loading />
	  } else {
	    let charts = []

	    if (this.props.level !== 0) {
	      let levelIndicators = this.state.levelIndicators
	      // if (Number(this.props.level) === 3) {
	        levelIndicators.forEach((subLevelIndicators, subLevel) => {
	          let numberOfRows = Math.ceil(subLevelIndicators.length / 2)
	          charts.push(
	            <p className={`ork-epigraph ork-epigraph--grey ${subLevel === 0 ? 'ork-u-mt-2' : 'ork-u-mt-4'} ork-u-mb-2`} key={`row${subLevel}`}>
	              <i>{this.getSubLevelTitle(subLevel)}</i>
	            </p>
	          )
	          for (let i = 0; i < numberOfRows; i++) {
	            charts.push(
	              <div className="row" key={`row${subLevel}.${i}`}>
	                {this.composeCharts({ indicator: subLevelIndicators[i * 2] })}
	                {subLevelIndicators[i * 2 + 1] ? this.composeCharts({ indicator: subLevelIndicators[i * 2 + 1] }) : null}
	              </div>
	            )
	          }
	        })
			/*
	      } else {
	        let numberOfRows = Math.ceil(levelIndicators.length / 2)
	        for (let i = 0; i < numberOfRows; i++) {
	          charts.push(
	            <div className="row" key={`row${i}`}>
	              {this.composeCharts({ indicator: levelIndicators[i * 2] })}
	              {levelIndicators[i * 2 + 1] ? this.composeCharts({ indicator: levelIndicators[i * 2 + 1] }) : null}
	            </div>
	          )
	        }
	      }
		  */
	    } else {
	      charts.push(
	        <div className="row" key={`row${1}`}>
	          {this.composeCharts({ indicator: this.props.indicator })}
	        </div>
	      )
	    }
	    renderingComponent = charts
	  }

	  return renderingComponent
	}

	render() {
	  return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
	}
}

export default injectIntl(ContentChartWrapper)



// WEBPACK FOOTER //
// ./src/modules/Content/ContentChart/ContentChartWrapper/ContentChartWrapper.jsx